import React, { useEffect, useState } from 'react';
import { Header } from 'react-frontier';
import { useTranslation } from 'react-i18next';
import { isJWT } from '@arema/components/Util';
import { useAuth } from '../AuthHooks';
import API from '../AuthAPI';

interface AccountConfirmProps{

}

var AccountConfirm = (props: AccountConfirmProps)=>{
	var { t } = useTranslation();
	var { params } = useAuth();
	var [accountConfirmed, setAccountConfirmed] = useState<boolean>(false);
	var [loadError, setLoadError] = useState<string>(null);

	useEffect(()=>{
		if(accountConfirmed) return;
		if(!isJWT(params.confirm_token)) return setLoadError('El token de confirmación no es válido');
		else setLoadError(null);
		
		API.confirmAccount(params.confirm_token).then(res=>{
			if(res.error) return setLoadError(res.message);
			setAccountConfirmed(true);
		}).catch(err=>{
			return setLoadError('Hubo un error inesperado confirmando la cuenta (LCL-ATHCFM-1)');
		});
	}, [accountConfirmed]);
	
	return <>
		{loadError ? (
			<Header text={"Error"} subtext={loadError} iconName='frown-open' contentStyle={{ marginTop: 15 }} />
		) : !accountConfirmed ? (
			<Header text={"Confirmando cuenta"} subtext={'Un segundo mientras confirmamos tu cuenta'} subheaderStyle={{ fontSize: 14 }} loading />
		) : (
			<Header text={"Cuenta confirmada"} subtext={'¡Tu correo electrónico ha sido confirmado!'} iconName='check-circle' />
		)}
	</>
}

export default AccountConfirm;